// http://develop.cxy61.com:8080/#/ActivityApply/vwktk26ftq39ghgz
<template>
  <div class="cropperImg">
    <div class="cropper_header">
      <span class="title">图片裁剪</span>
    </div>
    <div class="cropper_ground">
      <div class="cropper">
        <vueCropper
          ref="cropper"
          :img="src"
          :outputSize="option.size"
          :outputType="option.outputType"
          :info="true"
          :autoCrop="option.autoCrop"
          :fixed="option.fixed"
          :fixedNumber="[1, `${proportion}`]"
          :fixedBox="option.fixedBox"
          :canMove="option.canMove"
          :canMoveBox="option.canMoveBox"
          :original="option.original"
          :centerBox="option.centerBox"
          :infoTrue="option.infoTrue"
          @realTime="realTime"
          @imgLoad="imgLoad"
        >
        </vueCropper>
      </div>

      <div class="previewResult" :style="previewStyle">
        <div class="previewImg" :style="previews.div" v-if="previews">
          <img :src="previews.url" alt="" :style="previews.img" />
        </div>
      </div>
    </div>

    <div class="btns">
      <div class="left">
        <div class="btn" @click="rotateLeft()">左旋转</div>
        <div class="btn" @click="rotateRight()">右旋转</div>
        <div class="btn" @click="changeScale(1)">放大</div>
        <div class="btn" @click="changeScale(-1)">缩小</div>
      </div>
      <div class="right">
        <div class="btn" @click="submit('blob')">裁剪</div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";

export default {
  name: "CropperImg",
  props: {
    // 要裁剪的比例(高/宽)
    proportion: {
      type: Number,
      default: 1.5
    },
    // 要裁剪的图片
    src: {
      type: String
    },
  },
  components: {
    VueCropper
  },
  data() {
    return {
      option: {
        img:"",
        size: 1,
        outputType: "png",
        autoCrop: true, //是否显示截图框
        // autoCropWidth: 200, //截图框的宽
        // autoCropHeight: 300, // 截图框的高
        //是否开启截图框宽高固定比例
        fixed: true,
        //截图框的宽高比例
        // fixedNumber:[1, 1],
        // 是否固定截图框大小，不允许改变
        fixedBox: false,
        // 上传的图片是否可以移动
        canMove: true,
        // 截图框是否可以移动
        canMoveBox: true,
        // 上传的图片按照原始比例渲染
        original: true,
        // 截图框是否被限制在图片里面
        centerBox: false,
        // 是否按照设备的 dpr 输出等比例图片
        high: false,
        // true：展示真实输出图片宽高, false:展示看到的截图框宽高
        infoTrue: false,
        // 限制图片最大宽度和高度
        maxImgSize: 2000,
        // 图片根据截图框输出比例倍数
        enlarge: 1,
        //图片默认渲染模式
        mode: "contain"
      },
      previews: {},
      previewStyle: {},

      imgW: 200
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 图片预览数据
    realTime(data) {
      // console.log(data);
      let previews = data;

      // 固定宽度
      this.previewStyle = {
        width: previews.w + "px",
        height: previews.h + "px",
        overflow: "hidden",
        margin: "0",
        zoom: this.imgW / previews.w
      };

      this.previews = data;
    },
    // 图片加载
    imgLoad(msg) {
      // console.log('imgLoad')
      // console.log(msg)
    },

    //放大/缩小
    changeScale(num) {
      // console.log("changeScale");
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    //左旋转
    rotateLeft() {
      // console.log("rotateLeft");
      this.$refs.cropper.rotateLeft();
    },
    //右旋转
    rotateRight() {
      // console.log("rotateRight");
      this.$refs.cropper.rotateRight();
    },
    //确定
    submit(type) {
      if (type === "blob") {
        this.$refs.cropper.getCropBlob(data => {
          // let src = window.URL.createObjectURL(data)
          this.$emit("cropperEvent", data);
        });
      } else {
        this.$refs.cropper.getCropData(data => {
          // let src = window.URL.createObjectURL(data)
          this.$emit("cropperEvent", data);
        });
      }

    },
  },
  created() {},
  destroyed() {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.cropperImg {
  width: 700px;
  background-color: #ffffff;
  padding: 15px;
  margin: auto;
  border: solid 1px #e1e1e1;
  margin-top: 10px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}
.cropper_header {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 30px;
  margin-bottom: 10px;
  .title {
    color: #333333;
    font-size: 16px;
  }
  .close {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #ffffff;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transform: rotate(45deg);
    .line1 {
      position: absolute;
      width: 20px;
      height: 1.5px;
      background-color: #666666;
      top: calc(50% - 1px);
    }
    .line2 {
      width: 1.5px;
      height: 20px;
      background-color: #666666;
    }
  }
}
.cropper_ground {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .cropper {
    flex: 1;
    height: 300px;
    margin-right: 50px;
  }

  .previewResult {
    background-color: #f2f2f2;
    overflow: hidden;
    .previewImg {
      overflow: hidden;
    }
  }
}
.btns {
  width: 100%;
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .left{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .right{

  }
  .btn {
    width: 80px;
    text-align: center;
    color: #ff7b00;
    border: solid 1px #ff7b00;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    cursor: pointer;
    margin-right: 15px;
    border-radius: 5px;
  }
}

</style>
